import type { RoutePlan } from '@gpx-spa/geo-domain'
import { pathIdForSegment } from '@/utils/device-api-shipment-payload'

export function defaultSelectedByPathId(
  plan: RoutePlan | null | undefined,
): Record<string, boolean> {
  const next: Record<string, boolean> = {}
  if (!plan) return next
  for (let s = 0; s < plan.segments.length; s++) {
    const paths = plan.segments[s]?.paths ?? []
    for (let i = 0; i < paths.length; i++) {
      next[pathIdForSegment(s, paths[i]!, i)] = true
    }
  }
  return next
}

export function routeComposerPayloadSnapshot(input: {
  corridorBufferM: number
  geometryQualityPercent: number
  selectedByPathId: Record<string, boolean>
}): string {
  const sortedSelection = Object.keys(input.selectedByPathId)
    .sort()
    .reduce<Record<string, boolean>>((acc, key) => {
      acc[key] = input.selectedByPathId[key]!
      return acc
    }, {})
  return JSON.stringify({
    corridor_buffer_m: input.corridorBufferM,
    geometry_quality_percent: input.geometryQualityPercent,
    selected_by_path_id: sortedSelection,
  })
}

export function hasPersistableRoutePlan(
  plan: RoutePlan | null | undefined,
): boolean {
  if (!plan?.segments?.length) return false
  return plan.segments.some(
    (segment) => Array.isArray(segment.paths) && segment.paths.length > 0,
  )
}
